/** VISMARKS wordmark: red lightning logo + white lettering, same as the navbar. */
export function BrandMark({ className = "", size = "sm" }) {
  const img = size === "sm" ? "h-5 w-5" : "h-7 w-7";
  const text = size === "sm" ? "text-[11px] tracking-[0.3em]" : "text-sm tracking-[0.25em]";
  return (
    <span data-testid="brand-mark" className={`inline-flex items-center gap-2 font-black uppercase text-white ${text} ${className}`}>
      <img src="/logo.png" alt="" aria-hidden="true" className={`${img} rounded border border-[#FF3B30]/40 object-cover`} />
      <span>VISMARKS<span className="align-super text-[8px] ml-0.5 opacity-70" aria-label="trademark">™</span></span>
    </span>
  );
}
